import axios from '../utils/axios';

export const allCategories = async () =>
  await axios.get(`${process.env.REACT_APP_API}/categories`);

export const addCategory = async (category) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/add-category`, category);

export const deleteCategory = async (categoryId) =>
  await axios.delete(`${process.env.REACT_APP_API}/admin/category/delete/${categoryId}`);

export const getCategory = async (categoryId) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/category/edit/${categoryId}`);

export const editCategory = async (categoryId, category) =>
  await axios.put(`${process.env.REACT_APP_API}/admin/category/update/${categoryId}`, category);
